var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"crm-coupon-page"}},[_c('main-header',{attrs:{"title":_vm.title,"iconRightBtn":"history.png","isIconRightBtnFromFile":""},on:{"onClickRightBtn":_vm.onClickRightBtn}},[_c('CouponList')],1),_c('main-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }